import { SVGProps } from 'react';

const Navigation2Off = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.31 9.31 5 21l7-4 7 4-1.17-3.17m-3.3-8.95L12 2l-1.17 3.17M2 2l20 20"
    />
  </svg>
);
export default Navigation2Off;
